import styled from "@emotion/styled";
import { lodestarColors } from "@smartsheet/design-tokens";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import React, { forwardRef } from "react";
import { COMPONENT_TOKEN_PREFIX } from "../../../../constants/tokens";
import { Button, ButtonProps } from "../../../button";
import { Clickable } from "../../../clickable";

const { buttonPrimary, buttonPrimaryHover, buttonPrimaryPressed } = lodestarColors;
const componentTokenName = "date--picker--calendar--button";
const componentVarPrefix = `${COMPONENT_TOKEN_PREFIX}${componentTokenName}`;

export interface DatePickerCalendarButtonProps extends ButtonProps {
    isDisabled: boolean;
    themeMode: RequiredThemeKeys;
    children?: React.ReactNode;
    className?: string;
}

const DatePickerCalendarButtonBase = forwardRef((props: DatePickerCalendarButtonProps, ref) => {
    const { themeMode, ...rest } = props;
    if (themeMode.includes("ursa")) {
        return <Button {...rest} ref={ref as React.Ref<HTMLButtonElement>} />;
    }
    //@ts-expect-error complains about children not being included, but they are spread in the rest.
    return <Clickable {...rest} ref={ref as React.Ref<HTMLButtonElement>} />;
});

DatePickerCalendarButtonBase.displayName = "DatePickerCalendarButtonBase";

export const DatePickerCalendarButton = styled(DatePickerCalendarButtonBase)<DatePickerCalendarButtonProps>`
    &.is-disabled {
        display: none;
    }
    ${({ themeMode }) => {
        if (themeMode.includes("ursa"))
            return `
            margin-right: 3px;
            &:focus::before {
                inset: 0px;
                border-radius: 4px;
            }
        `;
        return `
            height: 24px;
            width: 24px;
            display: flex;
        
            color: var(${componentVarPrefix}--color, ${buttonPrimary});//no token available
            &:hover {
                color: var(${componentVarPrefix}--color--hover, ${buttonPrimaryHover});//no token available
            }
            &:active {
                color: var(${componentVarPrefix}--color--active, ${buttonPrimaryPressed});//no token available
            }
        `;
    }}
`;

DatePickerCalendarButton.displayName = "DatePickerCalendarButton";
